import {DangerButton} from "../../../components/CustomButton";
import EmptyState from "../../../components/EmptyState";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";
import BlogTag from "./BlogTag";
import {BLOGS_ITEMS_PER_PAGE} from "../constants";
import CustomIcon from "components/CustomIcon";

export default function ManageBlogGridLoader({count = BLOGS_ITEMS_PER_PAGE, error, retry, empty = false, isTag=false}) {


  return (


    !!error ?
      <div className="flex justify-center items-center">
        <div className="space-y-4 text-center flex flex-col items-center">
          <p className="text-red-500">{error ?? 'Error loading data.'}</p>
          <DangerButton onClick={retry}>Retry</DangerButton>
        </div>
      </div> : empty ? <EmptyState message={`No ${isTag ? 'tags':'blogs'} to display.`} icon="folder_open"/> :
      isTag ? <ManageBlogTagItemLoader count={count}/> :
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2 animate-pulse">
          {
            Array.from({length: count}, (_,i) => <ManageBlogGridItemLoader key={`blogs-loader-${i}`}/>)
          }


        </div>


  );
}

function ManageBlogGridItemLoader() {


  return (
    <div className="bg-secondary-100 border rounded-lg overflow-hidden">
      <div className="w-full aspect-[16/9] object-cover bg-loader"/>
      <div className="p-3 border-t">
        <div className="mb-1 w-full h-5 bg-loader"/>
        <div className="w-32 h-5 mb-1 bg-loader"/>
        <div className="text-xs mb-3 invisible">Published on 4/22/2024 </div>
        <div className="flex justify-between items-center invisible">
          <div className="link-sm">4 tags</div>
          <CustomIcon size="xl" icon="more_horiz" />
        </div>
      </div>
    </div>
  );
}

function ManageBlogTagItemLoader({count}) {


  return (
    <>
      {
        Array.from({length: count}, (_,i) => <BlogTag key={i} className="animate-pulse" />)
      }


    </>
  );
}

